import { CircleSkeleton, InputSkeleton, Skeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  ImageTextHeader,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={0} />

      <Container>
        <LeftSection>
          <CardContainer bodyClassName="flex">
            <PageHeaderContainer>
              <ImageTextHeader
                imageSlot={<CircleSkeleton className="size-28" />}
                primarySlot={<Skeleton className="mt-2 h-7 w-44" />}
                secondarySlot={<Skeleton className="mt-1 h-5 w-36" />}
              />
            </PageHeaderContainer>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
